import React from "react";
import PropTypes from "prop-types";
import HotTable from "react-handsontable";
import axios from "axios";
import Loading from "../general/Loading.js";

class ShiftImporter extends React.Component {
  state = {
    loading: true,
    users: [],
    shifts: [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ],
    colHeaders: [
      "Name",
      "Date *",
      "Start Time *",
      "End Time *",
      "Location *",
      "Position *",
      "Notes"
    ]
  };

  componentWillMount() {
    this.buildData();
  }

  buildData = () => {
    var that = this;
    var params = {
      location_id: "",
      visible_on_schedule: 1,
      active: 1,
      archived: 0,
      method: 'full_name_reverse'
    };

    axios({
      method: "get",
      url: "/users.json",
      params: params,
      responseType: "json"
    }).then(function(response) {
      that.setState({ loading: false });
      that.setState({ users: response.data });
    });
  };

  importShifts = () => {
    var that = this;

    axios
      .post("/shifts_import", {
        shifts: that.state.shifts
      })
      .then(function(response) {
        toastr.success(
          "Shifts have been imported, please check your email for confirmation"
        );
      })
      .catch(function(error) {
        toastr.error("Shifts not imported, check your email for errors");
        console.log(error);
      });
  };

  addRows = () => {
    var rows = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    var shifts = this.state.shifts;

    this.setState({ shifts: shifts.concat(rows) });
    toastr.success("Rows added");
  };

  reset = () => {
    var shifts = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    this.setState({ shifts: shifts });
    toastr.success("Grid has been cleared");
  };

  render() {
    var that = this;
    const width = { width: "1100px" };

    var columns = [
      {
        data: "fullName",
        type: "autocomplete",
        source: _.map(_.sortBy(this.state.users, ["full_name_reverse"]), "full_name_reverse"),
        strict: false
      },
      {
        data: "date",
        type: "date",
        dateFormat: "MM/DD/YYYY",
        correctFormat: true,
        allowEmpty: false
      },
      {
        data: "startTime",
        type: "time",
        correctFormat: true
      },
      {
        data: "endTime",
        type: "time",
        correctFormat: true
      },
      {
        data: "location",
        type: "autocomplete",
        source: _.map(_.sortBy(this.props.locations, ["name"]), "name"),
        strict: false
      },
      {
        data: "position",
        type: "autocomplete",
        source: _.map(
          _.sortBy(this.props.positions, ["priority", "name"]),
          "name"
        ),
        strict: false
      },
      {
        data: "notes",
        type: "text"
      }
    ];

    return (
      <div>
        <h1>Shifts Importer</h1>
        <p style={{ maxWidth: "100%", width: "100%", boxSizing: "border-box" }}>
          Copy and paste your shift data from Excel to add them into
          DigiQuatics. Don't have an Excel file already? Download our template
          <a
            className="styled-link"
            href="/download_excel_template.xlsx?template=shifts_importer"
          >
            {" "}
            here{" "}
          </a>
          to get started. To associate shifts with existing employees please include
          their full name so DigiQuatics can look up the correct employee.
          Shifts without an employee will be imported as "unassigned".
          <b> Note: All shifts imported are unpublished until reviewed and published on the schedule page.</b>
        </p>
        <a
          className="btn btn-pink btn-raised btn-long margin-right-five"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              that.importShifts();
            }
          }}
          onClick={() => that.importShifts()}
        >
          IMPORT
        </a>

        <a
          className="btn btn-indigo btn-raised btn-long margin-right-five"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              that.addRows();
            }
          }}
          onClick={() => that.addRows()}
        >
          ADD ROWS
        </a>
        <a
          className="btn btn-grey btn-raised btn-long"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              that.reset();
            }
          }}
          onClick={() => that.reset()}
        >
          RESET
        </a>
        <br />
        <br />
        {this.state.loading ? (
          <Loading loading={true} noDataMessage="" />
        ) : (
          <HotTable
            root="hot"
            data={this.state.shifts}
            rowHeaders={false}
            colWidths={[244, 122, 122, 122, 122, 122, 122, 122]}
            colHeaders={this.state.colHeaders}
            columns={columns}
            afterRender={() => {
              const copyPasteElement = document.getElementById("HandsontableCopyPaste");
              if (copyPasteElement) {
                copyPasteElement.setAttribute("aria-label", "Paste Area for Handsontable");
              }
            }}
          />
        )}
      </div>
    );
  }
}

ShiftImporter.propTypes = {
  locations: PropTypes.array,
  positions: PropTypes.array
};

export default ShiftImporter;
